import { Actions } from 'vuex-smart-module';
import { ResponseStatuses } from '@/enums';
import { AxiosResponse } from 'axios';
import { PurchaseOrderRequest, PurchaseOrders } from '../types';
import PurchaseOrdersState from './state';
import PurchaseOrdersMutations from './mutaitons';
import PurchaseOrdersGetters from './getters';
import { PurchaseOrdersService } from '../services';

const purchaseOrdersService = new PurchaseOrdersService();

export default class PurchaseOrdersActions extends Actions<
  PurchaseOrdersState,
  PurchaseOrdersGetters,
  PurchaseOrdersMutations,
  // eslint-disable-next-line no-use-before-define
  PurchaseOrdersActions
> {
  async get_purchase_orders() {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;

      const filtersEmpty = this.state.contractors_or_brands !== null && this.state.statuses !== null;

      const payload: PurchaseOrderRequest = {
        filters: this.state.filters,
        filters_exist: filtersEmpty,
        pagination: {
          limit: itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_LOADING(true);
      const { data, meta } = await purchaseOrdersService.get_purchase_orders(payload);

      this.mutations.SET_PURCHASE_ORDERS(data.items);

      if (!filtersEmpty) {
        this.mutations.SET_STATUSES(data.filters.statuses);
        this.mutations.SET_CONTRACTORS_OR_BRANDS(data.filters.contractors_or_brands);
      }

      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_LOADING(false);
    }
  }

  async get_purchase_order(id: string | number) {
    try {
      const { data, code = ResponseStatuses.Fail.FORBIDDEN } = await purchaseOrdersService.get_purchase_order(id);

      this.mutations.SET_PURCHASE_ORDER(data.purchase_order);
      this.mutations.SET_STATUSES(data.statuses);

      return code;
    } catch (error) {
      console.log(error);
      return (error as AxiosResponse).status;
    }
  }

  async update_purchase_order(payload: PurchaseOrders.UpdatePurchaseOrderPayload) {
    try {
      const { data, code = ResponseStatuses.Fail.FORBIDDEN } = await purchaseOrdersService.update_purchase_order(payload);

      this.mutations.SET_PURCHASE_ORDER_STATUS(data.status);

      return code;
    } catch (error) {
      console.log(error);
      return (error as AxiosResponse).status;
    }
  }

  async read(id: string | number) {
    try {
      await purchaseOrdersService.read(id);
    } catch (error) {
      console.log(error);
    }
  }
}
